import React, { useState } from "react";

export default function DropZoneWrapper({ onFiles, children }) {
  const [hover, setHover] = useState(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setHover(false);

    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) onFiles(files);
  };

  return (
    <div
      onDragOver={(e) => {
        e.preventDefault();
        setHover(true);
      }}
      onDragLeave={() => setHover(false)}
      onDrop={handleDrop}
      style={{
        border: hover ? "2px dashed #69cbf9" : "2px dashed transparent",
        borderRadius: 8,
        padding: 4,
        transition: "0.2s",
      }}
    >
      {children}
    </div>
  );
}
